/**
 * Time utility functions — display formatting and sorting helpers.
 */

/** Format HH:mm time string for display (12h or 24h). */
export function formatTime(timeString: string, use24h = false): string {
  const [hours, minutes] = timeString.split(':');
  const hour = parseInt(hours);
  if (use24h) return `${String(hour).padStart(2, '0')}:${minutes}`;
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 || 12;
  return `${displayHour}:${minutes} ${ampm}`;
}

/** Convert HH:mm time string to minutes since midnight (for sorting). */
export function timeToMinutes(timeString: string): number {
  const [hours, minutes] = timeString.split(':').map(Number);
  return hours * 60 + minutes;
}
